import { render, staticRenderFns } from "./OrderDetailSection.vue?vue&type=template&id=206f857a&scoped=true"
import script from "./OrderDetailSection.vue?vue&type=script&lang=js"
export * from "./OrderDetailSection.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailSection.vue?vue&type=style&index=0&id=206f857a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206f857a",
  null
  
)

export default component.exports